import React, {useEffect} from 'react';
import {useNavigation} from '@react-navigation/native';
import {Box, Input as NativeInput, FormControl} from 'native-base';
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import {defaultProps} from '../constants';
import {message} from '../../../utils/messages';
import {SecondaryButton} from '../../buttons';
import {NativeStackNavigationProp} from '@react-navigation/native-stack';
import {StackParamList} from '../../../navigators';
import {
  suscribeMapAreaEvent,
  unsuscribeMapAreaEvent,
} from './events/map-area-events';
import {CoordinateType} from './interfaces/coordinate-type';

interface Props extends UseControllerProps<any> {
  label: string;
  error:
    | Merge<
        FieldError,
        FieldErrorsImpl<{
          latitude: number;
          longitude: number;
        }>
      >
    | undefined
    | undefined;
  isRequired?: boolean;
  onFocus?: (event: Event) => void;
}

const MapAreaInput = (props: Props) => {
  const navigation = useNavigation<NativeStackNavigationProp<StackParamList>>();
  const {label, error, control, name, rules, isRequired} = props;
  const {field} = useController({
    control,
    defaultValue: '',
    name,
    rules,
  });

  const getErrorMessage = () => {
    return error != null ? message(error.message as string) : '';
  };

  const onMapButtontap = () => {
    navigation.navigate('MapModalScreen');
  };

  const listener = (coordinate: CoordinateType) => {
    field.onChange(coordinate);
  };

  useEffect(() => {
    suscribeMapAreaEvent(listener);
    return () => {
      unsuscribeMapAreaEvent();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showCoordinate = () => {
    if (field.value) {
      const coordinate = field.value as CoordinateType;
      return `Lat: ${coordinate.latitude.toFixed(
        6,
      )},  Long: ${coordinate.longitude.toFixed(6)}`;
    }
    return '';
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isInvalid={error != null} {...{isRequired}}>
        <FormControl.Label>{message(label)}</FormControl.Label>
        <NativeInput
          {...defaultProps}
          value={showCoordinate()}
          isReadOnly={true}
          color={'gray.400'}
        />
        <Box mb={0} mt={5}>
          <SecondaryButton
            label="map-area-action-button-label"
            onPress={() => onMapButtontap()}
            mt="-4"
          />
        </Box>
        <FormControl.ErrorMessage mt="0">
          {getErrorMessage()}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default MapAreaInput;
